// eslint-disable-next-line import/prefer-default-export

export const notificationsActions = {
    pushNotification: async ({ commit }, notification = {key: null, hide: false, type:"success", message: "Enregistrement effectué avec succès."}) => {
        notification.key = Date.now()
        notification.hide = false
        commit('PUSH_NOTIFICATION', notification)
        setTimeout(() => {
            commit('HIDE_NOTIFICATION', notification.key)
        }, 2000)
        setTimeout(() => {
            commit('REMOVE_NOTIFICATION', notification.key)
        }, 4000)
    },
};
